module.exports = function(comments) {
	'use strict'
	comments.directive('highlightWordsDir',highlightWordsDir);
	highlightWordsDir.$inject=[];
	function highlightWordsDir() {
		return {
			template: require('./partial/highlightWords.html'),
			controller:'highlightWordsController',
			controllerAs:'vmhwc',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/commentsModule/highlightWords/js/directive/highlightWordsDirective.js
// module id = 497
// module chunks = 0